import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const NPKChart = ({ npkData }) => {
  if (!npkData) return null;

  const data = {
    labels: ['Nitrogen (N)', 'Phosphorous (P)', 'Potassium (K)'],
    datasets: [
      {
        label: 'NPK Levels',
        data: [
          npkData.nitrogen?.value || 0,
          npkData.phosphorous?.value || 0,
          npkData.potassium?.value || 0,
        ],
        backgroundColor: [
          'rgba(56, 161, 105, 0.8)', // Green for Nitrogen
          'rgba(49, 130, 206, 0.8)', // Blue for Phosphorous
          'rgba(214, 158, 46, 0.8)', // Orange for Potassium
        ],
        borderColor: [
          'rgba(56, 161, 105, 1)',
          'rgba(49, 130, 206, 1)',
          'rgba(214, 158, 46, 1)',
        ],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          padding: 20,
          usePointStyle: true,
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.parsed || 0;
            const percentage = npkData[label.toLowerCase().split(' ')[0]]?.percentage || 0;
            return `${label}: ${value} mg/kg (${percentage}%)`;
          },
        },
      },
    },
    cutout: '60%',
  };

  return <Doughnut data={data} options={options} />;
};

export default NPKChart;
